@for(_ of [].constructor(5); track $index) {
    <ion-icon [name]="$index + 1 <= rating ? 'star' : halfStar && rating === $index + .5 ? 'star-half-outline' : 'star-outline'"
        [style.color]="getColor($index)" [class.disabled]="disabled" (click)="onRatingChanged($index)"></ion-icon>
}
